// extracted by mini-css-extract-plugin
module.exports = {"Container":"PkBzCU7c6RQqtqdpMGL4W","Dot":"_2SzZspyDISP9KzF8MhpBzw","Text":"_11E_xD8SM-oWMVDRwi7Yo_"};